<template>
  <v-app id="inspire">
    <v-app-bar
      app
      color="#43a047"
      dark
      shrink-on-scroll
      prominent
      src="../src/assets/header.jpg"
      fade-img-on-scroll
      scroll-target="#scrolling-techniques-5"
      scroll-threshold="500"
      hidden
    >
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          gradient="to top right, rgba(76,212,202,.9), rgba(25,32,72,.0)"
        ></v-img>
      </template>
      <v-container fluid>
        <v-row>
          <v-app-bar-nav-icon></v-app-bar-nav-icon>

          <v-spacer></v-spacer>

          <v-btn icon>
            <v-icon>mdi-magnify</v-icon>
          </v-btn>

          <!-- SignIn/SignUp Button -->
          <v-btn icon v-if="!user" @click="showSignInModal = true">
            <v-icon>mdi-login</v-icon>
          </v-btn>

          <!-- User Icon if Logged In -->
          <v-menu offset-y v-if="user">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-account</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="signOut">
                <v-list-item-title>Sign Out</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="space-around">
          <v-avatar class="profile mt-n10" size="180" tile>
            <img
              src="../src/assets/GT Collective-logos_transparent.png"
              alt="GT Collective"
            />
          </v-avatar>
        </v-row>
      </v-container>
      <template v-slot:extension>
        <v-tabs align-with-title>
          <v-tab>Marketplace</v-tab>
          <v-tab>Services</v-tab>
          <v-tab>Contact</v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <v-col>
            <MarketPlace />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <!-- SignIn Modal -->
    <v-dialog
      v-model="showSignInModal"
      persistent
      max-width="600px"
      @click:outside="showAuthModal = false"
    >
      <SignIn @closeModal="showSignInModal = false" />
    </v-dialog>

    <!-- <v-bottom-navigation v-model="value" color="grey" dark grow app>
      <v-btn style="color: #4cd4ca">
        All
        <v-icon>mdi-garage</v-icon>
      </v-btn>
      <v-btn style="color: #4cd4ca">
        GT
        <v-icon>mdi-car-sports</v-icon>
      </v-btn>
      <v-btn style="color: #4cd4ca">
        Touring
        <v-icon>mdi-car-side</v-icon>
      </v-btn>
      <v-btn style="color: #4cd4ca">
        Track Day
        <v-icon>mdi-train-car-flatbed-car</v-icon>
      </v-btn>
      <v-btn style="color: #4cd4ca">
        Parts
        <v-icon>mdi-wrench-cog</v-icon>
      </v-btn>
    </v-bottom-navigation> -->
  </v-app>
</template>

<script>
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import SignIn from "./components/SignIn";
import MarketPlace from "./components/MarketPlace";

export default {
  name: "App",
  computed: {
    color() {
      switch (this.value) {
        case 0:
          return "#4cd4ca";
        case 1:
          return "teal";
        case 2:
          return "teal darken-2";
        case 3:
          return "grey darken-2";
        case 4:
          return "grey darken-3";
        default:
          return "#4cd4ca";
      }
    },
  },

  components: {
    MarketPlace,
    SignIn,
  },
  created() {
    onAuthStateChanged(auth, (user) => {
      this.user = user;
    });
  },
  methods: {
    signOut() {
      auth.signOut();
    },
  },
  data: () => ({
    user: null,
    showSignInModal: false,
    value: null,
    links: ["Dashboard", "Messages", "Profile", "Updates"],
  }),
};
</script>
